export default "__VITE_ASSET__239c6f4c__"